<template>
  <tr class="marketing-sms-list-item">
    <td>
      <span v-tooltip="isScheduledOrIsWaitingSchedule ? formattedSchedulerDate : ''">{{ status }}</span>
    </td>

    <td>
      {{ item.title }}
    </td>

    <td >
      <span v-tooltip.right="item.isEstimated ? $t('message.marketingGenerics.message.estimatedSendAmount') : ''">{{ sendingAmount }}</span>
    </td>

    <td>
      {{ sentDate }}
    </td>

    <td class="marketing-sms-list-item-actions">
      <marketing-sms-list-item-actions :item="item"
                                       :is-automation="isAutomation"
                                       @duplicated="emitDuplicated"
                                       @deleted="emitDeleted"
                                       @edited="emitEdited" />
    </td>
  </tr>
</template>

<script>
import MarketingSmsListItemActions from "@components/modules/marketing/sms/list/item/actions/MarketingSmsListItemActions";

export default {
  components: {
    MarketingSmsListItemActions,
  },
  data() {
    return {};
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isAutomation: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    creationDate() {
      return this.$date.format(this.item.creationDate);
    },
    sentDate() {
      return this.item.sentDate
        ? this.$date.formatDateAndHour(this.item.sentDate)
        : "-";
    },
      sendingAmount() {
          let amount = 0
          if(this.item.isEstimated) {
              amount = this.item.sendingAmount || 0;
          } else {
              amount = this.item.sentAmount;
          }
          return amount;
      },
    status() {
      return {
        ["DRAFT"]: this.$t('message.generics.message.draft'),
        ["SCHEDULED"]: this.$t('message.marketingGenerics.message.scheduled'),
        ["SENT"]: this.$t('message.marketingGenerics.message.sent'),
        ["SENDING"]: this.$t('message.marketingGenerics.message.sending'),
        ["PARTIALLY_SENT_BY_CREDIT"]: this.$t('message.marketingGenerics.message.partiallySent'),
        ["PARTIALLY_SENT_BY_SYSTEM"]: this.$t('message.marketingGenerics.message.partiallySent'),
        ["EXECUTING"]: this.$t('message.marketingGenerics.message.executing'),
        ["LINKED_WITH_FLOW"]: this.$t('message.marketingGenerics.message.linkedWithFlow'),
        ["WAITING_SCHEDULE"]: this.$t('message.marketingGenerics.message.waitingToBeSent'),
        ["ERROR"]: this.$t('message.marketingGenerics.message.error'),
      }[this.item.status];
    },
    isScheduledOrIsWaitingSchedule() {
      if(this.item.status === "SCHEDULED" || this.item.status === "WAITING_SCHEDULE") {
        return true
      } else {
        return false
      }
    },
    formattedSchedulerDate() {
      let fomattedDateAndTime
      if(this.item.schedulerDate) {
        const date = this.item.schedulerDate.split(" ")[0]
        const time = this.item.schedulerDate.split(" ")[1]
        const dateArray = date.split("-")
        const timeArray = time.split(":")
        fomattedDateAndTime = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]} - ${timeArray[0]}:${timeArray[1]}`
      }
      return fomattedDateAndTime
    }
  },
  methods: {
    emitDuplicated() {
      this.$emit("duplicated");
    },
    emitDeleted() {
      this.$emit("deleted");
    },
    emitEdited() {
      this.$emit("edited");
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-sms-list-item {
  td {
    .help {
      color: $primary;
    }
  }
  .marketing-sms-list-item-actions {
    i {
      margin-right: 5px;
    }

    svg {
      color: #707070;
    }
  }
}
</style>
